import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, ChevronDown } from 'lucide-react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Contact from '../components/Contact';
import FAQ from '../components/FAQ';
import { companyInfo } from '../constants';

const Home = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div className="flex-shrink-0">
              <h1 className="text-xl sm:text-2xl font-bold text-sky-700">
                {companyInfo.name}
              </h1>
              <p className="text-xs sm:text-sm text-gray-600">{companyInfo.fullName}</p>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-sky-600 transition-colors">
                Ana Sayfa
              </button>
              <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-sky-600 transition-colors">
                Hizmetler
              </button>
              <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-sky-600 transition-colors">
                Hakkımızda
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-sky-600 transition-colors">
                S.S.S.
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-sky-600 transition-colors">
                İletişim
              </button>
            </nav>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <ChevronDown className={`w-6 h-6 transition-transform ${isMenuOpen ? 'rotate-180' : ''}`} />
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="md:hidden pb-4 space-y-2">
              <button onClick={() => scrollToSection('hero')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors">
                Ana Sayfa
              </button>
              <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors">
                Hizmetler
              </button>
              <button onClick={() => scrollToSection('about')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors">
                Hakkımızda
              </button>
              <button onClick={() => scrollToSection('faq')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors">
                S.S.S.
              </button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors">
                İletişim
              </button>
            </nav>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main>
        <div id="hero">
          <Hero />
        </div>
        <div id="services">
          <Services />
        </div>
        <div id="about">
          <About />
        </div>
        <div id="faq">
          <FAQ />
        </div>
        <div id="contact">
          <Contact />
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Company Info */}
            <div>
              <h3 className="text-xl font-bold mb-4 text-sky-400">{companyInfo.name}</h3>
              <p className="text-gray-300 mb-2">{companyInfo.fullName}</p>
              <p className="text-gray-400 text-sm">Lisans No: {companyInfo.license}</p>
              <p className="text-gray-400 text-sm">{companyInfo.authority}</p>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-sky-400">İletişim</h4>
              <div className="space-y-2 text-gray-300">
                <div className="flex items-center space-x-2">
                  <Phone className="w-4 h-4" />
                  <span>{companyInfo.phone1}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Phone className="w-4 h-4" />
                  <span>{companyInfo.phone2}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Mail className="w-4 h-4" />
                  <span>{companyInfo.email}</span>
                </div>
              </div>
            </div>

            {/* Address */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-sky-400">Adres</h4>
              <div className="flex items-start space-x-2 text-gray-300">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-1" />
                <span>{companyInfo.address}</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300 mt-4">
                <Clock className="w-4 h-4" />
                <span>Pazartesi - Cuma: 09:00 - 18:00</span>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
            <p>&copy; 2025 {companyInfo.name}. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;